import { FC } from 'react';
import { CustomCard } from '@mybonum/ui';

import { PracticesFilter } from './components/filter';
import { PracticesTable } from './components/table';
import { useColumns } from './hooks/use-columns.tsx';
import { TPracticeType } from './types.ts';

import { ColumnsVisibilityProvider } from '@/contexts/column-visibility';

export const Practices: FC = () => {
    const columns = useColumns();

    return (
        <CustomCard>
            <ColumnsVisibilityProvider<TPracticeType>
                storageKey="practices_table"
                columns={columns}
                requiredColumnsKeys={['id']}
            >
                <PracticesFilter />
                <PracticesTable />
            </ColumnsVisibilityProvider>
        </CustomCard>
    );
};
